import React, { useMemo, useState } from "react";
import { format, isSameDay } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import { eventDays, formatRange } from "@/lib/dates";

export function EventsCalendar({ events, onOpen }: { events: any[]; onOpen: (e: any) => void }) {
  const [day, setDay] = useState<Date | undefined>(new Date());
  const allDays = useMemo(() => events.flatMap((e) => eventDays(e.start_date, e.end_date)), [events]);
  const onDay = day ? events.filter((e) => eventDays(e.start_date, e.end_date).some((d) => isSameDay(d, day))) : [];
  return (
    <div className="mb-6 flex flex-col gap-4 rounded-sm border bg-card p-3 sm:flex-row" data-testid="events-calendar">
      <Calendar
        mode="single"
        selected={day}
        onSelect={setDay}
        modifiers={{ hasEvent: allDays }}
        modifiersClassNames={{ hasEvent: "!font-bold underline decoration-primary decoration-2 underline-offset-4" }}
        className="self-center sm:self-start"
      />
      <div className="min-w-0 flex-1 space-y-2 sm:pt-3" data-testid="events-calendar-day-list">
        <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-muted-foreground">{day ? format(day, "EEEE, MMM d, yyyy") : "Pick a day"}</p>
        {day && onDay.length === 0 && <p className="text-sm text-muted-foreground" data-testid="events-calendar-empty">No events on this day.</p>}
        {onDay.map((e) => (
          <button key={e.id} type="button" onClick={() => onOpen(e)} className="block w-full rounded-sm border-l-2 border-primary bg-muted px-3 py-2 text-left transition-colors hover:bg-muted/70" data-testid={`events-calendar-item-${e.id}`}>
            <span className="block text-sm font-semibold">{e.name}</span>
            <span className="block text-xs text-muted-foreground">{[formatRange(e.start_date, e.end_date), e.venue, e.booth && `Booth ${e.booth}`].filter(Boolean).join(" · ")}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
